var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChats(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_709_4632)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.3521 17.7961H11.326L4.86945 23.2424V17.7961H3.52577C2.0413 17.7961 0.835938 16.5759 0.835938 15.0717V4.17897C0.835938 2.67721 2.0413 1.45703 3.52577 1.45703H22.3521C23.8366 1.45703 25.0419 2.67721 25.0419 4.18144V15.0741C25.0419 16.5759 23.8366 17.7961 22.3521 17.7961ZM23.6983 4.18144C23.6983 3.43056 23.0956 2.818 22.3521 2.818H3.52577C2.7823 2.818 2.17962 3.42809 2.17962 4.18144V15.0741C2.17962 15.825 2.7823 16.4351 3.52577 16.4351H4.86945H6.21313V19.1595L10.2466 16.4376H12.9389H22.3521C23.0956 16.4376 23.6983 15.8275 23.6983 15.0766V4.18144ZM18.3186 10.9863C17.5751 10.9863 16.9749 10.3762 16.9749 9.62532C16.9749 8.87444 17.5751 8.26188 18.3186 8.26188C19.0621 8.26188 19.6647 8.87197 19.6647 9.62532C19.6623 10.3787 19.0596 10.9863 18.3186 10.9863ZM12.9389 10.9863C12.1955 10.9863 11.5953 10.3762 11.5953 9.62532C11.5953 8.87444 12.1955 8.26188 12.9389 8.26188C13.6824 8.26188 14.2826 8.87197 14.2826 9.62532C14.2826 10.3787 13.6824 10.9863 12.9389 10.9863ZM7.55928 10.9863C6.81581 10.9863 6.21313 10.3762 6.21313 9.62532C6.21313 8.87444 6.81581 8.26188 7.55928 8.26188C8.30275 8.26188 8.90296 8.87197 8.90296 9.62532C8.90543 10.3787 8.30275 10.9863 7.55928 10.9863Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_709_4632"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.7,
    height: 24.7,
    fill: "white",
    transform: "translate(0.588867)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChats);
export default __webpack_public_path__ + "static/media/chats.e0dcb651be5052ba071f908e01eb5b7d.svg";
export { ForwardRef as ReactComponent };